<template>
  <div class="map-menu">
    <div class="head-line" >
      <b-button :pressed.sync="hideAllFilters" 
                variant="primary" 
                class="head-btn" 
                size="md">
        <font-awesome-layers>
          <font-awesome-icon :icon="['fas', 'bars']"
                              style="color: white;"
                              transform="grow-1 left-1"  />
        </font-awesome-layers>
      </b-button>
      <div class="head-lbl">
        <span class="header">{{ $t('Webportal.Map.Options') }}</span>
      </div>
      <div  v-show="showBrandSelection" 
            style="width: 100%;" 
            :class="{'hide': this.hideAllFilters}">
        <b-button variant="outline-primary"
                  style="float: right; margin-right: 4px; margin-left: auto;"
                  class="outline-primary map-opt-button"
                  v-on:click="showG6B6Report">
          {{ $t('Webportal.Map.G6B6Report') }}
        </b-button>
<!--         
        <b-button variant="outline-primary"
                  style="float: right; margin-right: 4px; margin-left: auto;"
                  class="outline-primary"
                  v-on:click="showCountries">
          NSC Table
        </b-button> -->
      </div>
    </div>

    <div class="map-opt-grid" :class="{'hide': this.hideAllFilters}">
      <div class="map-opt-item">

      </div>
      <div class="map-opt-item" v-if="showClientSelection">
        <client-selection buttonText="Continue" class="client-sel" />
      </div>
      <div class="map-opt-item">
        <treeselect-control :header="$t('Webportal.CX.BMW.KPI')"
                            :toolTipIconShow="false"
                            :selectedBrand="selectedBrand"
                            :toolTipText="$t('Webportal.CX.BMW.KPI.Tooltip')"
                            placeholder="Waiting for data ..."
                            selectedEventName="selected-kpi-changed"
                            itemsListenEventName="kpi-data" />
      </div>
      <div class="map-opt-item">
        <options-switch :header="$t('Webportal.CX.BMW.MapMode')"
                        :toolTipIconShow="false"
                        :toolTipText="$t('Webportal.CX.BMW.MapMode.Tooltip')"
                        selectedEventName="show-dealers-changed"
                        :itemData="mapModeSetting" />
      </div>
      <div class="map-opt-item" v-show="showBrandSelection">
        <options-switch :header="$t('Webportal.CX.BMW.Brand')"
                        :toolTipIconShow="false"
                        :toolTipText="$t('Webportal.CX.BMW.Brand.Tooltip')"
                        selectedEventName="selected-brand-changed"
                        :showIcons="true"
                        :itemData="brandsData" />
      </div>
      <div class="map-opt-item">
        <options-switch :header="$t('Webportal.CX.BMW.Year')"
                        :toolTipIconShow="false"
                        :toolTipText="$t('Webportal.CX.BMW.Year.Tooltip')"
                        selectedEventName="selected-year-changed"
                        :itemData="yearSetting" />
      </div>

      <div class="map-opt-item">
        <options-switch :header="$t('Webportal.CX.BMW.Timeframe')"
                        :toolTipIconShow="false"
                        :toolTipText="$t('Webportal.CX.BMW.Timeframe.ToolTip')"
                        :disabled="true"
                        selectedEventName="selected-time-setting-changed"
                        :itemData="timeSettingItems" />
      </div>

      <div class="map-opt-item pt-4">
        <span class="pl-0 header ">{{ $t('Webportal.CX.BMW.PerformanceIndex') }}</span>
        <small-legend :thresholdData="getActiveThreshold" />
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import EventBus from "@/services/EventBus.js";
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import ClientSelection from "@/components/ClientSelection";
import OptionsSwitch from './OptionsSwitch.vue';
import TreeselectControl from './TreeselectControl.vue';
import SmallLegend from './SmallLegend.vue';

export default {
  props: {
    brandsData: Object,
    selectedBrand: String,
    thresholdData: Array
  },

  data() {
    return {
      hideAllFilters: false,
      mapModeSetting: {
        selected: 'showDealers',
        options: [
          { text: 'Dealer', value: 'showDealers' },
          { text: 'NSC', value: 'NSC' }
        ]
      },
      yearSetting: {
        selected: '2025',
        options: [
          { text: '2024', value: '2024', disabled: false },
          { text: '2025', value: '2025', disabled: false },
        ]
      },
      timeSettingItems: {
        selected: 'ytd',
        options: [
          { text: this.$t('Webportal.Dashboard.YTD'), value: 'ytd', disabled: false },
          { text: this.$t('Webportal.CX.Dashboard.Topbar.Current'), value: 'current', disabled: false }
        ]
      },
      client: null,
      clientItems: [],

      kpiThreshold: undefined,
    };
  },

  mixins: [ AppConfig ],

  components: {
    ClientSelection, OptionsSwitch, SmallLegend, TreeselectControl
  },
  
  mounted() {
    EventBus.$on("client-selection-changed", (x) => {
      this.client = x;
    });
    EventBus.$on("client-collection-changed", (x) => {
      this.clientItems = x;
    });
    EventBus.$on("kpi-threshold-changed", (x) => {
      this.kpiThreshold = x;
    });
  },

  beforeDestroy() {
    EventBus.$off("client-selection-changed");
    EventBus.$off("client-collection-changed");
    EventBus.$off("kpi-threshold-changed");
  },

  methods: {
    showG6B6Report() {
      EventBus.$emit('show-g6b6-countries');
    },
    showCountries() {
      EventBus.$emit('countries-grid-show');
    }
  },

  computed: {
    showBrandSelection() {
      return this.client?.ClientName && !this.client.ClientName.startsWith('BMW Motorrad');
    },

    showClientSelection() {
      return this.clientItems && this.clientItems?.length !== 1;
    },

    getActiveThreshold() {
      return this.kpiThreshold ? this.kpiThreshold : this.thresholdData;
    }
  }
}
</script> 

<style lang="scss" scoped>
  
  .client-sel #clientSelector {
    max-width: 76.25% !important;
    margin-left: 0px !important;
  } 

  .map-offset {
    padding: 0.2rem;
  }

  .map-menu {
    background-color: rgba(255,255,255,0.92);
    box-shadow: 0px 0px 4px 4px rgba(223,223,223,0.5);
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 0.25rem;
    font-family: 'BmwCondensed',Verdana,Geneva,sans-serif;
    font-size: 14px;
    font-weight: 400;
  }

  .hide {
    display: none !important; 
  }

  .map-opt-grid {
    width: 21.75rem;
    margin: 0.75rem;
    display: block;
    text-align: unset !important;
  }

  .client-sel {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  .head-line {
    display: flex;
    margin: 0.75rem;
  }

  .head-lbl {
    align-self: center;
  }

  .header {
    font-size: 18px;
    font-weight: 500;
    padding-left: 1rem;
    position: relative;
    display: inline;
  }

</style>
